import { useEffect, useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FaChartLine, FaLocationArrow, FaCloudSun } from 'react-icons/fa'
import { MdLocationOn, MdKitesurfing } from 'react-icons/md'
// import { FaHome } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import more from 'highcharts/highcharts-more'
import { find } from 'lodash'
import { format } from 'date-fns'

import {
  useSessionWS,
  useRestricted,
  useTrkptsWS,
  useListBoards,
  useListSails,
  useLang,
  useMobile,
} from '../utils/hooks'

import TabInfos from '../components/TabInfos'
import WindInfos from '../components/WindInfos'
import TimeSpeedChart from '../components/TimeSpeedChart'
import SpeedList from '../components/SpeedList'
import SpeedFrequencyChart from '../components/SpeedFrequencyChart'
import Help from '../components/Help'
import HelpNotif from '../components/HelpNotif'

import { LoaderWrapper, Loader } from '../components/StyledElements'

import { langSession } from '../assets/langSession'
import {
  chartColors,
  k_kmh_to_knts,
  smallTextClass,
  kGlobalView,
  kPathView,
  kGPSDataView,
  kRigsUsedView,
  kMeteoView,
} from '../assets/colors'

import {
  getSessionData,
  getChartData,
  getSpeedData,
  getTrkptsFromStr,
} from '../assets/assets_functions.js'
import Footer from '../components/Footer'
import SessionWSTracks from './SessionWSTracks'
import SessionModify from '../components/SessionModify'
import ModifySession from './ModifySession'
import Rigs from './Rigs'
import Meteo from './Meteo'
import MobileStatLink from '../components/MobileStatLink'
import StatLink from '../components/StatLink'

const Stats2 = () => {
  const firstDiv = useRef(null)

  const { mobile } = useMobile()
  const { sessionWS } = useSessionWS()
  const { restricted } = useRestricted()
  const { trkptsWS, changeTrkptsWS } = useTrkptsWS()
  const { listBoards } = useListBoards()
  const { listSails } = useListSails()
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langSession.fr : langSession.eng

  const chart = useRef(null)

  const [isLoading, setIsLoading] = useState(false)
  const [center, setCenter] = useState(null)
  const [polygon, setPolygon] = useState(null)
  const [chartOptions, setChartOptions] = useState(null)
  const [timeDomain, setTimeDomain] = useState(null)
  const [restrictedTimeDomain, setRestrictedTimeDomain] = useState(null)
  const [maxSpeed, setMaxSpeed] = useState(null)
  const [speedRanges, setSpeedRanges] = useState(null)
  const [speedDistRanges, setSpeedDistRanges] = useState(null)
  const [distance, setDistance] = useState({ origin: null, distance: 0 })
  const [max5Speed, setMax5Speed] = useState(null)

  const [speedFrequencyChartData, setSpeedFrequencyChartData] = useState({})

  const [windStats, setWindstats] = useState(null)

  const [rigs, setRigs] = useState([])
  const [rigsLegend, setRigsLegend] = useState()
  const [showHelp, setShowHelp] = useState(false)

  const [whichView, setWhichView] = useState(kGlobalView)
  const [updateRigs, setUpdateRigs] = useState(true)

  let navigateTo = useNavigate()

  useEffect(() => {
    if (!sessionWS) {
      const local_userId = localStorage.getItem('wsurf_userId')
      if (Number(local_userId) !== -1) navigateTo('/sessions/')
      else navigateTo('/')
    }
  }, [])

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    if (!sessionWS) return
    if (trkptsWS.brut.length > 0) return
    setIsLoading(true)
    const url = '/api/tzip/loadTZip'
    const sessionId = sessionWS._id
    const data = { sessionId }
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        response.json().then((data) => {
          // const temp_trkpts = getTrkptsFromStr(data[0].trkpts)
          const temp_trkpts = getTrkptsFromStr(data)
          changeTrkptsWS({
            brut: temp_trkpts,
            origin: 'mdb',
          })
        })
      })
      .catch((error) => {
        console.log('Error getting trkpts for session ' + sessionWS._id, error)
      })
  }, [sessionWS])

  useEffect(() => {
    if (updateRigs === false) return
    if (!sessionWS) return
    setIsLoading(true)
    const url = '/api/rig/getRigsForSession'
    const sessionId = sessionWS._id

    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
      }),
    })
      .then((response) => {
        response.json().then((rigsData) => {
          let i = -1
          const temp = rigsData.map((rig, index) => {
            const tempBoard = find(
              listBoards.initialData,
              (board) => board._id === rig.boardId,
            )
            const tempSail = find(
              listSails.initialData,
              (sail) => sail._id === rig.sailId,
            )
            return (
              <span className={' tag ' + chartColors[++i].tag} key={index}>
                {tempBoard.model +
                  ' ' +
                  tempBoard.volume +
                  ' + ' +
                  tempSail.model +
                  ' ' +
                  tempSail.surface.toFixed(1)}
              </span>
            )
          })
          setRigs(rigsData)
          setRigsLegend(temp)
          setUpdateRigs(false)
        })
      })
      .catch((error) => {
        console.log('Error getting rigs for session ' + sessionWS._id, error)
      })
  }, [sessionWS, updateRigs])

  useEffect(() => {
    if (!sessionWS) return
    if (trkptsWS.brut.length === 0) return
    setIsLoading(true)
    const temp_trkpts = trkptsWS.brut

    const { center, polygon, timeDomain, restrictedTimeDomain } =
      getSessionData(temp_trkpts)

    const { chartOptions, max5Speed } = getChartData(
      trkptsWS.brut,
      sessionWS.timeZone,
      restricted,
      'stats',
      rigs,
      choosenLang.speedChartTitle,
      choosenLang.speedChartY,
    )

    const { speedRanges, speedDistRanges, distance, speedFrequency } =
      getSpeedData(temp_trkpts, restricted)

    let temp_speedFrequency = []
    speedFrequency.forEach((value, index) =>
      temp_speedFrequency.push([index, value]),
    )
    setCenter(center)
    setPolygon(polygon)

    setChartOptions(chartOptions)
    setTimeDomain(timeDomain)
    setRestrictedTimeDomain(restrictedTimeDomain)
    setMaxSpeed(sessionWS.maxSpeed)
    setSpeedRanges(speedRanges)
    setSpeedDistRanges(speedDistRanges)
    setDistance(sessionWS.distance)
    setMax5Speed(max5Speed)

    setSpeedFrequencyChartData(temp_speedFrequency)
    setIsLoading(false)
  }, [trkptsWS, restricted, sessionWS, rigs])

  const handleSelectNewSpeedItem = (itemIndex, x, y, kind) => {
    let temp_options
    if (itemIndex !== -1) {
      switch (kind) {
        case 'GPS':
          temp_options = {
            ...chartOptions,
            annotations: [
              {
                labels: [
                  {
                    point: {
                      x: x,
                      y: y,
                      xAxis: 0,
                      yAxis: 0,
                    },
                  },
                ],
                zIndex: 7,
                labelOptions: {
                  formatter: function () {
                    return (
                      '' +
                      '<span style="font-size: 10px">' +
                      format(new Date(this.x), 'HH:mm:ss', {
                        timeZone: sessionWS.timeZone,
                      }) +
                      '</span></br>' +
                      Math.round(this.y * 10) / 10 +
                      ' knts</b><br/>'
                    )
                  },
                  backgroundColor: Highcharts.color('#2FE654')
                    .setOpacity(0.85)
                    .get(),
                  borderWidth: 1,
                  shadow: true,
                  padding: 8,
                  distance: 16,
                  borderRadius: 3,
                  borderColor: Highcharts.getOptions().colors[0],
                  style: {
                    color: '#333333',
                    cursor: 'default',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                  },
                },
              },
            ],
          }

          break
        /* case 'Calc':
                temp_options = {...speed_calc_chart_options, 
                  annotations: [{
                    labels: [{
                                point: 'max_'+(itemIndex + 1),
                                distance: 40
                            }]
                  }]
                };
                setCalcSpeedChartOptions ({type: 'VIEW_CALC_MAX', payload: temp_options});
                break; */
        default:
          break
      }
    } else {
      temp_options = {
        ...chartOptions,
        annotations: [],
      }
    }
    setChartOptions(temp_options)
  }

  //meteo data stats
  useEffect(() => {
    if (!sessionWS) return
    if (sessionWS.meteoStationId) {
      const timeU = new Date(sessionWS.restrictedStartSession).getTime()
      const sessionStart = timeU
      const sessionEnd = timeU + sessionWS.restrictedSessionDuration * 1000
      const data = {
        start: sessionStart,
        end: sessionEnd,
        baliseId: sessionWS.meteoStationId,
      }
      const url = '/api/windstat/getBetweenDates'
      const dc = decodeURIComponent(document.cookie)
      const sdc = dc.split('=')[1]
      const ws = sdc.split(';')[0]
      fetch(url, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          authorization: 'ws ' + ws,
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          response.json().then((stats) => {
            let nbStats = 0
            let maxTotal = 0
            let maxMax = 0
            let maxMin = 100
            let avgTotal = 0
            let avgMax = 0
            let avgMin = 100
            let dirTotal = 0
            let dirMax = 0
            let dirMin = 600
            stats.forEach((stat) => {
              nbStats += 1
              avgTotal += Math.round(stat.avgSpeed * k_kmh_to_knts * 10) / 10
              if (stat.avgSpeed < avgMin) avgMin = stat.avgSpeed
              if (stat.avgSpeed > avgMax) avgMax = stat.avgSpeed

              maxTotal += Math.round(stat.maxSpeed * k_kmh_to_knts * 10) / 10
              if (stat.maxSpeed < maxMin) maxMin = stat.maxSpeed
              if (stat.maxSpeed > maxMax) maxMax = stat.maxSpeed

              dirTotal += stat.direction
              if (stat.direction < dirMin) dirMin = stat.direction
              if (stat.direction > dirMax) dirMax = stat.direction
            })
            if (nbStats > 0) {
              setWindstats({
                avgMin: Math.round(avgMin * k_kmh_to_knts * 10) / 10,
                avgAvg: Math.round((avgTotal * 10) / nbStats) / 10,
                avgMax: Math.round(avgMax * k_kmh_to_knts * 10) / 10,
                maxMin: Math.round(maxMin * k_kmh_to_knts * 10) / 10,
                maxAvg: Math.round((maxTotal * 10) / nbStats) / 10,
                maxMax: Math.round(maxMax * k_kmh_to_knts * 10) / 10,
                dirMin: Math.round(dirMin),
                dirAvg: Math.round(dirTotal / nbStats),
                dirMax: Math.round(dirMax),
              })
            }
          })
        })
        .catch((error) => {
          console.log('error getting stats for session ' + sessionWS._id, error)
        })
    }
  }, [sessionWS])

  const handleToView = (whichView, e) => {
    setWhichView(whichView)
    e.preventDefault()
  }

  const handleToGlobal = (e) => {
    setWhichView(kGlobalView)
    e.preventDefault()
    // navigateTo(`/oneSessionTracks/`, {
    //   state: {
    //     center: center,
    //     polygon: polygon,
    //   },
    // })
  }

  const handleToParcours = (e) => {
    setWhichView(kPathView)
    e.preventDefault()
    // navigateTo(`/oneSessionTracks/`, {
    //   state: {
    //     center: center,
    //     polygon: polygon,
    //   },
    // })
  }

  const handleToModify = (e) => {
    setWhichView(kGPSDataView)
    e.preventDefault()
    // navigateTo(`/modify/`, {
    //   state: {
    //     center: center,
    //     polygon: polygon,
    //   },
    // })
  }

  const handleToRigs = (e) => {
    setWhichView(kRigsUsedView)
    e.preventDefault(e)
    // navigateTo('/rigs/', { state: { rigsData: rigs, rigsFs: rigs } })
  }

  const handleToMeteo = (e) => {
    setWhichView(kMeteoView)
    e.preventDefault(e)
    // navigateTo('/meteo/', {
    //   state: {
    //     timeDomain: timeDomain,
    //     restrictedTimeDomain: restrictedTimeDomain,
    //   },
    // })
  }

  const handleHelp = (what) => {
    setShowHelp(what)
  }

  const backToSessions = () => {
    navigateTo(`/sessions`)
  }

  const handleUpdateStats = (which) => {
    switch (which) {
      case kRigsUsedView:
        setUpdateRigs(true)
        break
      case kGPSDataView:
        break
      default:
        return
    }
    setWhichView(kGlobalView)
  }

  return isLoading ? (
    <LoaderWrapper>
      <Loader data-testid="loader" />
    </LoaderWrapper>
  ) : (
    center && (
      <div>
        <section className="section pt-4 pr-0" ref={firstDiv}>
          {sessionWS._id !== undefined && (
            <>
              <div className="level is-mobile">
                <div className="level-item">
                  <div className="level-left">
                    {/* <div className="columns">
                <div className="column"> */}
                    <nav
                      className="breadcrumb is-size-5"
                      aria-label="breadcrumbs"
                    >
                      <ul>
                        <li>
                          <Link to="/sessions">{choosenLang.sessionsLink}</Link>
                        </li>
                        <li className="is-active">
                          <a href="/" aria-current="page">
                            {choosenLang.sessionStatsLink}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                {/* </div> */}

                <div className="level-item">
                  <div className="level-right">
                    {!mobile && (
                      <table className="table">
                        <tbody>
                          <tr>
                            <td>
                              <div className="tag is-warning">
                                {sessionWS.sessionTitle}
                              </div>
                            </td>
                            <td>
                              <div className="tag is-white">
                                {choosenLang.sourceFile + sessionWS.fileName}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                    {/* {mobile && (
                      <div className="tag is-warning">
                        {sessionWS.sessionTitle}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>

              <div className="columns background-very-light-info">
                {!mobile && (
                  <div className="column is-1 has-background-white">
                    <aside className="menu">
                      <ul className="menu-list">
                        <StatLink
                          title={choosenLang.statsLink}
                          view={kGlobalView}
                          isSelectedView={whichView === kGlobalView}
                          Icon={FaChartLine}
                          handleToView={handleToView}
                        />
                        <StatLink
                          title={choosenLang.pathLink}
                          view={kPathView}
                          isSelectedView={whichView === kPathView}
                          Icon={FaLocationArrow}
                          handleToView={handleToView}
                        />
                        <StatLink
                          title={choosenLang.gpsLink}
                          view={kGPSDataView}
                          isSelectedView={whichView === kGPSDataView}
                          Icon={MdLocationOn}
                          handleToView={handleToView}
                        />
                        <StatLink
                          title={choosenLang.rigsLink}
                          view={kRigsUsedView}
                          isSelectedView={whichView === kRigsUsedView}
                          Icon={MdKitesurfing}
                          handleToView={handleToView}
                        />
                        <StatLink
                          title={choosenLang.meteoLink}
                          view={kMeteoView}
                          isSelectedView={whichView === kMeteoView}
                          Icon={FaCloudSun}
                          handleToView={handleToView}
                        />
                      </ul>
                    </aside>
                  </div>
                )}
                <div className={`column ${!mobile ? 'pr-4' : ''}`}>
                  {mobile && (
                    <>
                      <div className="level is-mobile">
                        <MobileStatLink
                          title={choosenLang.statsLink}
                          view={kGlobalView}
                          isSelectedView={whichView === kGlobalView}
                          Icon={FaChartLine}
                          handleToView={handleToView}
                        />

                        <MobileStatLink
                          title={choosenLang.pathLink}
                          view={kPathView}
                          isSelectedView={whichView === kPathView}
                          Icon={FaLocationArrow}
                          handleToView={handleToView}
                        />
                        <MobileStatLink
                          title={choosenLang.gpsLink}
                          view={kGPSDataView}
                          isSelectedView={whichView === kGPSDataView}
                          Icon={MdLocationOn}
                          handleToView={handleToView}
                        />
                        <MobileStatLink
                          title={choosenLang.rigsLink}
                          view={kRigsUsedView}
                          isSelectedView={whichView === kRigsUsedView}
                          Icon={MdKitesurfing}
                          handleToView={handleToView}
                        />
                        <MobileStatLink
                          title={choosenLang.meteoLink}
                          view={kMeteoView}
                          isSelectedView={whichView === kMeteoView}
                          Icon={FaCloudSun}
                          handleToView={handleToView}
                        />
                      </div>
                    </>
                  )}
                  {whichView === kGlobalView && (
                    <div>
                      <div className="block">
                        <div className="grid">
                          <div className="cell">
                            <TabInfos
                              timeDomain={
                                restricted ? restrictedTimeDomain : timeDomain
                              }
                              timeZone={sessionWS.timeZone}
                              maxSpeed={maxSpeed}
                              distance={distance}
                            />

                            {windStats && <WindInfos windStats={windStats} />}
                          </div>

                          <div className="cell">
                            <TimeSpeedChart
                              speedRanges={speedDistRanges}
                              type={'distance'}
                            />
                          </div>

                          <div className="cell">
                            <TimeSpeedChart
                              speedRanges={speedRanges}
                              type={'time'}
                            />
                          </div>

                          <div className="cell">
                            <SpeedFrequencyChart
                              data={speedFrequencyChartData}
                              id="speed_frequency_chart_div"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="block">
                        <div className="grid">
                          <div className="cell is-col-span-4">
                            {!isLoading && (
                              <>
                                <HighchartsReact
                                  ref={chart}
                                  highcharts={Highcharts}
                                  options={chartOptions}
                                />
                                <div className="is-flex is-justify-content-space-evenly">
                                  {rigsLegend}
                                </div>
                              </>
                            )}
                          </div>

                          <div className="cell">
                            <SpeedList
                              listeSpeed={max5Speed}
                              handleSelectNewSpeedItem={
                                handleSelectNewSpeedItem
                              }
                              kind={'GPS'}
                              textClass={smallTextClass}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {whichView === kPathView && (
                    <SessionWSTracks
                      coords={{
                        center: center,
                        polygon: polygon,
                      }}
                    />
                  )}
                  {whichView === kGPSDataView && (
                    <ModifySession handleUpdateStats={handleUpdateStats} />
                  )}
                  {whichView === kRigsUsedView && (
                    <Rigs
                      data={{ rigsData: rigs, rigsFs: rigs }}
                      handleUpdateStats={handleUpdateStats}
                    />
                  )}
                  {whichView === kMeteoView && (
                    <Meteo
                      data={{
                        timeDomain: timeDomain,
                        restrictedTimeDomain: restrictedTimeDomain,
                      }}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </section>
        <Footer />
      </div>
    )
  )
}

export default Stats2
